import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Form,
	Button,
	Input,
	Select,
	Checkbox,
} from 'antd'
import {
	CommonValue,
	url,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';
import CryptoJS from 'crypto-js';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'siteList':[],
			'rules':{
				'admin_name':[
					{
						required: true,
						message: '请输入登录账号',
					},
				],
				'password':[
					{
						required: true,
						message: '请输入密码',
					},
				],
				'site_id':[
					{
						required: true,
						message: '请选择工厂',
					},
				],
				'captcha':[
					{
						required: true,
						message: '请输入验证码',
					},
				],
			},
			'captchaUrl':url('/index/index/captcha'),
		};
	}
	
	componentDidMount()
	{
		this.getSiteList();
		document.title = '扫码登录';
		global.setScanState({
			'headScope':{
				'leftButton':null,
				'title':'',
			},
		});
		
		let info = CommonValue.get('scan_login_info');
		if(info)
		{
			let words = CryptoJS.enc.Base64.parse(info);
			info = words.toString(CryptoJS.enc.Utf8);	
			info = JSON.parse(info);
			this.mainForm && this.mainForm.setFieldsValue(info);
			
			//this.captchaRef.focus();
			//$(this.rootNode).find('[name="captcha"]').trigger('focus');
		}
		else
		{
			//this.adminNameRef.focus();
			//$(this.rootNode).find('[name="admin_name"]').trigger('focus');
		}
	}
	
	getSiteList()
	{
		let url = pcUrl('index','siteList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'siteList':data,
				});
			});
	}
	
	submit(form)
	{
		let url = pcUrl('index','adminLogin');
		let param = form;
		httpPost(url,param)
			.then(data=>{
				let adminInfo = data;
				CommonValue.set('admin_info',adminInfo);
				
				if(form.remember)
				{
					let loginInfo = {
						'admin_name':param['admin_name'],
						'password':param.password,
						'remember':param.remember,
						'site_id':param['site_id'],
						'captcha':'',
					};
					loginInfo = JSON.stringify(loginInfo);
					//保存表单
					let wordArray = CryptoJS.enc.Utf8.parse(loginInfo);
					loginInfo = CryptoJS.enc.Base64.stringify(wordArray);
					
					CommonValue.set('scan_login_info',loginInfo);
				}
				
				this.props.history.push('/scan/index');
			});
	}
	
	render()
	{
		return (
			<div className="m-login">
				<h3>用户登录</h3>
				<Form
					labelCol={{ span:8 }}
					wrapperCol={{ span:16 }}
					onFinish={(data)=>this.submit(data)}
					ref={e=>this.mainForm = e}>
					<Form.Item label="" name="admin_name" rules={this.state.rules['admin_name']}>
						<Input size="large" placeholder="登录账号" ref={e=>this.adminNameRef = e} />
					</Form.Item>
					<Form.Item label="" name="password" rules={this.state.rules['password']}>
						<Input size="large" type="password" placeholder="请输入密码" />
					</Form.Item>
					<Form.Item label="" name="site_id" rules={this.state.rules['site_id']}>
						<Select size="large" placeholder="请选择工厂">
							{this.state.siteList.map(row=>(
								<Select.Option value={row['site_id']}>{row['site_name']}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="" name="captcha" rules={this.state.rules['captcha']} shouldUpdate={(old,cur)=>cur['captcha'] != old['captcha']}>
						<Input size="large" placeholder="验证码" onChange={e=>this.mainForm && this.mainForm.setFieldsValue({'captcha':e.target.value})} style={{'width':'8em'}} ref={e=>this.captchaRef = e} />
						&nbsp;&nbsp;
						<a href="javascript:;" onClick={()=>this.setState({'captchaUrl':url('/index/index/captcha')+"?"+Math.random()})}>
							<img src={this.state.captchaUrl} style={{'border':'1px solid #DDD','height':'36px'}} />
						</a>
					</Form.Item>
					
					<Form.Item name="remember" hidden></Form.Item>
						<div style={{'marginBottom':'1em','textAlign':'left'}}>
							<label>
								<Form.Item noStyle shouldUpdate={(old,cur)=>cur.user_name != old.user_name}>
									{()=>(
									<Checkbox checked={this.mainForm && this.mainForm.getFieldValue('remember')} onChange={e=>{this.mainForm.setFieldsValue({'remember':e.target.checked?1:0});}}>记住密码</Checkbox>
									)}
								</Form.Item>
							</label>
						</div>
					<div>
						<Button size="large" style={{'width':'100%'}} type="primary" htmlType="submit">确认</Button>
					</div>
				</Form>
			</div>
		);
	}
}



